import React, { useEffect, useRef, useState } from 'react'
import worker from '../../assets/Images/worker.png'
import { Header, MainButton } from '../../Components/index'
import Geocode from "react-geocode"
Geocode.setApiKey("AIzaSyDtZ2MI9NVtHQAJeF4BWYtIXonio-e4lA4")

const Address = (props) => {
    const { setAddress, setValue,  setCenter } = props
    const autoCompleteRef = useRef()
    const inputRef = useRef()
    const options = {
        componentRestrictions: { country: ['fr'] },
        fields: ["address_components", "geometry", "icon", "name"],
        types: ["establishment"]
    }

    useEffect(() => {
        if (inputRef?.current?.value) {
            getLatLongUsingAddress()
        }
    }, [inputRef?.current?.value])

    const getLatLongUsingAddress = () => {
        try {
            Geocode.fromAddress(inputRef?.current?.value).then(
                (response) => {
                    // setCenter({ lat:0, lng :0})
                    const { lat, lng } = response?.results[0]?.geometry?.location
                    setCenter({ lat, lng })
                    console.log({ lat, lng });
                },
                (error) => {
                }
            )
        } catch (e) {
        }
    }
    useEffect(() => {
        setTimeout(() => {
            autoCompleteRef.current = new window.google.maps.places.Autocomplete(
                inputRef?.current,
                options
            )
        }, 3000)
    }, [])
    return (
        <>
            <div>
                <Header heading='Simulez votre projet photovoltaique !' />
                <div className='inner_div'>
                    <div className='worker_div' >
                        <img src={worker} className='worker_img' />
                    </div>
                    <div className='section_container '>
                        <div className="section">
                            <div className='step_progress'>
                                <div className='address_step'></div>
                                <div className='step'></div>
                                <div className='step'></div>
                                <div className='step'></div>

                            </div>
                            <div className='address_container'>
                                <div className='address_section'>
                                    <h1 className='heading'>Quelle est votre adresse ?</h1>
                                    <div>
                                        <input onChange={(e) => setValue(inputRef?.current?.value)} className='inp' placeholder='12 rue du petit, 69000 Calet' ref={inputRef} />
                                    </div>
                                    <div className="addres_btn" onClick={() => {
                                        getLatLongUsingAddress()
                                        setValue(inputRef?.current?.value)
                                        setAddress(true)
                                    }}>
                                        <MainButton disabled={inputRef?.current?.value ? false : true} title='Suivant' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Address